module.exports = __webpack_public_path__ + "img/RotatingWarning.d808a1de.svg";